<template>
  <div
    class="cg-badge"
    :class="badgeClasses"
    :style="badgeVariables"
  >
    <!-- @slot The default Vue slot. -->
    <slot>
      {{ content }}
    </slot>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { Colors } from '../../utils/Colors';

import { BadgeSize } from '../../types'

export default Vue.extend({
  name: 'CgBadge',
  props: {
    /**
     * Specify badge size.
     * @values small | medium | large
     */
    size: {
      type: String as PropType<BadgeSize>,
      required: false,
      default: BadgeSize.Small,
    },
    /**
     * Applies specified background color.
     */
    color: {
      type: String as PropType<Colors | String>,
      required: false,
      default: Colors.Green500,
    },
    /**
     * Applies specified font color.
     */
    fontColor: {
      type: String as PropType<Colors | String>,
      required: false,
      default: Colors.White,
    },
    /**
     * The content that will be in the badge.
     */
    content: {
      type: [String, Number],
      required: false,
      default: null,
    },
  },
  computed: {
    badgeClasses(): Array<string> {
      const { size } = this;

      const result: Array<string> = [];

      if (size === BadgeSize.Large) {
        result.push('cg-badge--large');
      } else if (size === BadgeSize.Medium) {
        result.push('cg-badge--medium');
      }

      return result;
    },
    badgeVariables(): Object {
      const { color, fontColor } = this;

      return {
        '--badge-color': color,
        '--badge-text-color': fontColor,
      };
    }
  },
});
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
